/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import RangeSlider from "./SliderComponent";
import SelectDropdown from "./SelectDropdown";

export default function EnvironmentLight({
  updateEnvironmentLight,
  applyEnvironmentIntensity,
  currentConfig,
  updateConfig,
  getHDRIOptions,
}) {
  const [exposureValue, setExposureValue] = useState(
    currentConfig?.exposure ?? 0
  );
  const [environmentLight, setEnvironmentLight] = useState(currentConfig?.name);
  const getRemainingMaterials = () => {
    return getHDRIOptions().map((e) => {
      return { label: e.name, value: e.name };
    });
  };
  return (
    <div className="envLightContainer">
      <div className="envLightHeader">
        <div className="envLightHeaderInfo">
          <div className="title">Environment Light</div>
        </div>
      </div>
      <div className="formWrapper">
        <div className="materialActions">
          <SelectDropdown
            value={environmentLight}
            placeholder="Select Environment"
            menuList={getRemainingMaterials()}
            onMenuSelect={async (value) => {
              const envConfig = getHDRIOptions().find((e) => e.name === value);
              console.log("dropdown selected", value);
              currentConfig = { ...envConfig };
              const updatedConfig = await updateEnvironmentLight(currentConfig);
              setEnvironmentLight(updatedConfig.name);
              setExposureValue(updatedConfig.exposure);
              applyEnvironmentIntensity(currentConfig.exposure);
              updateConfig(updatedConfig);
            }}
          />
        </div>
        {environmentLight && (
          <div className="sliderWrapper">
            <>
              <Form.Label>Exposure</Form.Label>
              <RangeSlider
                onSliderChange={(value) => {
                  console.log("on ambient light slider", value);
                  currentConfig.exposure = value;
                  setExposureValue(value);
                  applyEnvironmentIntensity(value);
                }}
                onAfterChange={(value) => {
                  applyEnvironmentIntensity(currentConfig.exposure);
                  updateConfig(currentConfig);
                }}
                value={exposureValue}
                max={5}
                step={0.5}
              />
            </>
          </div>
        )}
      </div>
    </div>
  );
}
